/* TrackerBase App Current Time Zone "provider"
 *
 * Angular Module: trackerbase-app.services.current-time-zone
 * Injected Service: CurrentTimeZone
 *
 
 *
 */

import moment from "moment-timezone";
import angular from "angular";

import Assert from "tbAssert";

const mLogSvc = new WeakMap();
const mStorageSvc = new WeakMap();

class CurrentTimeZoneService {
    constructor(store, $log) {
        Assert.StrictAssert(store != null, "Assertion failure: Missing Store Service Dependency");
        Assert.StrictAssert($log != null, "Assertion failure: Missing Log Service Dependency");

        mStorageSvc.set(this, store);
        mLogSvc.set(this, $log);

        this._useDetectedTZ = mStorageSvc.get(this).get("useDetectedTZ");

        if (this._useDetectedTZ == null) {
            this._useDetectedTZ = true;
            mStorageSvc.get(this).set("useDetectedTZ", this._useDetectedTZ);
        }

        this._detectedTimeZone = moment.tz.guess();

        this._profileTimeZone = mStorageSvc.get(this).get("userOverrideTZ");

        if (this._profileTimeZone == null) {
            this._profileTimeZone = this._detectedTimeZone;
            mStorageSvc.get(this).set("userOverrideTZ", this._profileTimeZone);
        }

        this._makeSelectedTimeZoneDefault();
    }

    toString() {
        return "CurrentTimeZoneService";
    }

    _setUseDetectedTimeZone(useDetectTZ) {
        if ((angular.isDefined(useDetectTZ)) &&
            (typeof(useDetectTZ) === "boolean"))
        {
            this._useDetectedTZ = useDetectTZ;
            mStorageSvc.get(this).set("useDetectedTZ", this._useDetectedTZ);
            this._makeSelectedTimeZoneDefault();
        }
        else {
            throw new TypeError("_setUseDetectedTimeZone: Invalid or missing parameter.");
        }
    }

    _makeSelectedTimeZoneDefault() {
        moment.tz.setDefault(this.selectedTimeZone);
    }

    get selectedTimeZone() {
        if (this._useDetectedTZ) {
            return this._detectedTimeZone;
        }
        else {
            return this._profileTimeZone;
        }
    }

    get() {
        return this.selectedTimeZone;
    }

    useDetectedTimeZone() {
        this._setUseDetectedTimeZone(true);
    }

    useProfileTimeZone() {
        this._setUseDetectedTimeZone(false);
    }

    isUsingDetectedTimeZone() {
        return this._useDetectedTZ;
    }

    get profileTimeZone() {
        return this._profileTimeZone;
    }

    set profileTimeZone(tzName) {
        if (moment.tz.zone(tzName) != null) {
            this._profileTimeZone = tzName;
            mStorageSvc.get(this).set("userOverrideTZ", this._profileTimeZone);
        }
        else {
            mLogSvc.get(this).error("Invalid Time Zone: " + tzName);
        }
    }

    get detectedTimeZone() {
        return this._detectedTimeZone;
    }
}

CurrentTimeZoneService.$inject = [ "store", "$log" ];

export default angular
    .module("trackerbase-app.services.current-time-zone",[
        "angular-storage"
    ])
    .service("CurrentTimeZone", CurrentTimeZoneService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/CurrentTimeZoneService.js
// module id = I/O/
// module chunks = 1